import mixpanel from 'mixpanel-browser';
export const useMixpanel = () => {
  const trackEvent = (event: string, data = {}) => {
    mixpanel.track(event, data);
  };
  return {
    trackEvent,
  };
};
